/**
 * URL do backend (server-side / BFF).
 * Preferir API_URL (não público); fallback NEXT_PUBLIC_API_URL.
 */
export function getBackendUrl(): string {
  const raw =
    process.env.API_URL ||
    process.env.NEXT_PUBLIC_API_URL ||
    process.env.NEXT_PUBLIC_API_URL_LOCAL ||
    "http://localhost:3333";

  return raw.replace(/\/$/, "");
}
